import { REMOVE_INDICATION } from './actionTypes';

const removeIndication = query => ({ type: REMOVE_INDICATION, payload: query });

export default removeIndication;
